import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * ### **RegisterSuccessComponent**
 *
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el
 * Componente encargado de renderizar el mensaje de confirmación para los usuarios que recien se registran.
 */
@Component({
  selector: 'app-register-success',
  imports: [TranslateModule, MatDialogModule],
  templateUrl: './register-success.html',
  styleUrl: './register-success.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegisterSuccess {
  public readonly dialogRef = inject(MatDialogRef<RegisterSuccess>);
  public readonly data = inject(MAT_DIALOG_DATA) as { edited: boolean };

  /** Variable que guardara el mensaje que llega desde un componente externo*/
  protected readonly edited = signal<boolean>(false);

  /**
   * Función nativa de las clases en typescript que se encarga de inicializar las variables para
   * el correcto funcionamiento del componente en esta caso inicializa la variable edited con los
   * datos que recibe de otro componente.
   * @param dialogRef Parametro que se referencia asi mismo para poder comportarse como modal.
   * @param data Parametro que recibe la informacion que es inyectada una vez llaman al componente
   */
  constructor() {
    if (this.data) {
      this.edited.set(this.data.edited);
    }
  }
}
